import addPrefix from './withParentPrefix';

const ROUTES = {
  ROOT: '/',
  LOGIN: '/login',
  OA_LOGIN: 'oa-login',
  OA_SIGN_UP_OR_LOGIN: '/oa-sign-up-or-login',
  LOGOUT: '/logout',
  PASSWORD_RESET: '/password-reset',
  NEW_PASSWORD: '/new-password',
  SIGN_UP: '/sign-up',
  CREATE_USERNAME: '/create-username',
  VERIFY_PHONE: '/verify-phone',
  HELP: '/help',
  CHILD_REGISTRATION_LANDING: '/child-registration-landing',
  PROGRAMMES: addPrefix('/programmes', {
    THEME: '/theme',
    TIMING: '/timing',
    SUMMARY: '/summary',
    ROUTINE: '/routine',
  }),
  ATTENDANCE_TUTORIAL_WALKTHROUGH: '/attendance-tutorial-walkthrough',
  DASHBOARD: '/dashboard',
  BUSINESS: '/business',
  BUSINESS_ADD_AMOUNT: '/business-add-amount',
  BUSINESS_ADD_INCOME: '/business-add-income',
  BUSINESS_UPDATE_INCOME: '/business-update-income',
  BUSINESS_ADD_EXPENSE: '/business-add-expense',
  BUSINESS_UPDATE_EXPENSE: '/business-update-expense',
  BUSINESS_PREVIOUS_STATEMENTS_LIST: '/business-previous-statements-list',
  BUSINESS_MONTH_STATEMENTS_DETAILS: '/month-statements-details',
  BUSINESS_REGISTRATION: '/registration',
  BUSINESS_REGISTRATION_UPDATE: '/registration-update',
  CALENDAR: '/calendar',
  CLASSROOM: addPrefix('/classroom', {
    CHILDREN: '/children',
    ATTENDANCE: addPrefix('/attendance', {
      EDIT_REGISTERS: '/edit-registers',
      MONTHLY_REPORT: '/monthly-report',
    }),
    ACTIVITIES: addPrefix('/activities', {
      PROGRAMME_DASHBOARD: addPrefix('/programme-dashboard/:classroomGroupId', {
        TUTORIAL: addPrefix('/tutorial', {
          GETTING_STARTED: '/getting-started',
          DAILY_ROUTINE: '/daily-routine',
          DEVELOPING_CHILDREN: '/developing-children',
        }),
      }),
    }),
    UPDATE_FEE: '/preschool-fee',
  }),
  TRAINING: '/training',
  COMMUNITY: addPrefix('/community', {
    HELP: '/help/:helpSection',
    WELCOME: '/welcome',
    PROFILE: '/profile',
    CONNECTION_PROFILE: '/connection-profile',
    ECD_HEROES_LIST: '/ecd-heroes-list',
    RECEIVED_REQUESTS: '/received-requests',
  }),
  CHILD: addPrefix('/child', {
    INFORMATION: addPrefix('/information', {
      EDIT: '/edit',
    }),
  }),
  PRACTITIONER_PROGRESS_REPORT_SUMMARY: '/progress-summary-report',
  CHILD_REGISTRATION: '/child-registration',
  CHILD_REGISTRATION_BIRTH_CERTIFICATE: '/child-registration-birth-certificate',
  PRINCIPAL: addPrefix('/principal', {
    ADD_PRACTITIONER: '/add-practitioner',
    CONFIRM_PRACTITIONER: 'confirm-practitioner',
    SETUP_PROFILE: '/setup-profile',
    PRACTITIONER_PROFILE: '/practitioner-profile',
    PRACTITIONER_LIST: '/practitioner-list',
    PRACTITIONER_CHILD_LIST: '/practitioner-child-list',
    PRACTITIONER_REASSIGN_CLASS: '/practitioner-reassign-class',
    PRACTITIONER_REMOVE_FROM_PROGRAMME: '/remove-practitioner-from-programme',
    SWAP_PRINCIPAL: '/swap-principal',
    NOTES: '/notes',
    CONTACT_PRACTITIONER: '/contact-practitioner',
  }),
  PRACTITIONER: addPrefix('/practitioner', {
    ABOUT: addPrefix('/about', {
      SIGNATURE: '/signature',
    }),
    ACCOUNT: '/account',
    PROGRAMME_INFORMATION: '/programme-information',
    PROFILE: addPrefix('/profile', {
      PLAYGROUPS: '/playgroups',
      EDIT: '/edit',
    }),
    POINTS: addPrefix('/points', {
      SUMMARY: '/summary',
      YEAR: '/year',
    }),
    CONTACT_COACH: '/contact-coach',
    HELP: addPrefix('/help', {
      VIDEOS: '/videos',
      DOWNLOAD: '/download',
      CHAT: '/chat',
    }),
  }),
  CHILD_NOTES: '/child-notes',
  CHILD_PROFILE: '/child-profile',
  CHILD_CAREGIVERS: '/child-caregivers',
  CHILD_ATTENDANCE_CAREGIVER: '/child-attendance-caregiver',
  CHILD_ATTENDANCE_REPORT: '/child-attendance-report',
  REMOVE_CHILD: '/remove-child',
  CHILD_PRESCHOOL_FEES: '/preschool-fees',
  MESSAGES: '/messages',
  PROGRESS_TRACKING_CATEGORY: '/progress-tracking-category',
  PROGRESS_SETUP_REPORTING_PERIODS: '/setup-progress-reporting-period',
  PROGRESS_OBSERVATIONS: '/progress-observations',
  PROGRESS_OBSERVATIONS_LANDING: '/progress-observations-landing',
  PROGRESS_OBSERVATIONS_NOTES: '/progress-observations-notes',
  PROGRESS_REPORT_LIST: '/child-progress-skill-tracking',
  PROGRESS_SELECT_CHILD_TO_TRACK: '/progress-select-child',
  PROGRESS_SELECT_CATEGORY_TO_TRACK: '/progress-select-category',
  PROGRESS_OBSERVATIONS_BY_CATEGORY: '/progress-observations-by-category',
  PROGRESS_CREATE_REPORT: '/progress-create-report',
  PROGRESS_SHARE_REPORT: '/progress-share-report',
  PROGRESS_VIEW_REPORT: '/progress-view-report',
  PROGRESS_VIEW_REPORTS_SUMMARY_SELECT_CLASSROOM_GROUP_AND_AGE_GROUP:
    '/progress-view-reports-summary-select',
  PROGRESS_VIEW_REPORTS_SUMMARY: '/progress-view-reports-summary',
  COACH_REGISTRATION: '/coach-registration',
  COACH_SELF_ASSESSMENT: '/coach-self-assessment',
  COACH: addPrefix('/coach', {
    ABOUT: addPrefix('/about', {
      SIGNATURE: '/signature',
      ADDRESS: '/address',
    }),
    PRACTITIONERS: '/practitioners',
    PRACTITIONER_PROFILE_INFO: '/practitioner-profile-info',
    PRACTITIONER_REASSIGN_CLASS: '/practitioner-reassign-class',
    PRACTITIONER_JOURNEY: '/practitioner-journey/:practitionerId',
    PRACTITIONER_POINTS: '/practitioner-points/:userId',
    PRACTITIONER_BUSINESS: addPrefix('/practitioner-business', {
      BUSINESS: '/:userId',
      LIST_STATEMENTS: '/:userId/previous-statements-list',
      STATEMENT_DETAILS: '/:userId/statement-details',
    }),
    PRACTITIONER_CLASSROOM: '/practitioner-classroom',
    PRACTITIONER_CHILD_LIST: '/practitioner-childlist',
    PRACTIONER_REMOVE: '/practioner-remove',
    PROGRAMME_INFORMATION: '/programme-information',
    CLASSES_REASSIGNED: '/classes-reassigned',
    CHILD_PROFILE: '/child-profile',
    CONTACT_PRACTITIONER: '/contact-practitioner',
    NOTES: '/notes',
    ACCOUNT: '/account',
    PROFILE: addPrefix('/profile', {
      EDIT: '/edit',
    }),
    COACH_PROGRESS_VIEW_REPORTS_SUMMARY_SELECT_CLASSROOM_GROUP_AND_AGE_GROUP:
      '/coach-progress-view-reports-summary-select',
    COACH_PROGRESS_VIEW_REPORTS_SUMMARY: '/coach-progress-view-reports-summary',
  }),
};

export default ROUTES;
